import React from 'react'
import styled from 'styled-components'
import { LIGHTGRAY } from '../../styles/colors.style'

const StyledBadge = styled.div`
	font-size: 2.2rem;
	text-align: center;
	width: 12rem;
	height: 12rem;
	border-radius: 15.7rem;
	background: #e8effc;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-shadow: 0px 9px 15px -5px ${LIGHTGRAY};
	transform: rotate(-15deg);

	@media (min-width: 361px) {
		width: 15.7rem;
		height: 15.7rem;
		font-size: 2.8rem;
	}
`

const PointConvertBadge = () => (
	<StyledBadge className="point-converter-badge">
		<span className="blue italic">R$1,00</span>
		<span className="yellow">=</span>
		<span className="orange italic">5 Pontos</span>
	</StyledBadge>
)

export default PointConvertBadge
